import React , { useState, useRef } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Style from '../Styles/DashboardStyle.module.css';
import DashboardTitle from './DashboardTitle'
import DashBoardLeftProfileMenu from "./DashBoardLeftProfileMenu";
import { paymentForUser} from "../../services/routes.services";
import { useSelector } from 'react-redux';
import { Link } from "react-router-dom";
import html2canvas from "html2canvas";
import { RiDownload2Fill } from "react-icons/ri";
import constants from "../../services/constants";

const DashBoardMembership =()=>{
const { user,token } = useSelector((state) => state.auth);
const idCardRef = useRef();
 const [userData] = useState({
    firstname: user.name,
    email: user.email,
    phone: user.phone
  });
 const handlePayment = async () => {
    const paymentData = {
      firstname: userData.firstname,
      email: userData.email,
      phone: userData.phone,
      amount: 7500,
      productinfo: 'membership'
    };

    try {
      const response = await paymentForUser(paymentData,token);
      // Redirect or handle response
      if(response.status==200){

        // Open payment URL in a new tab
        const paymentUrl = `https://pay.easebuzz.in/pay/${response.data.data}`;
        window.open(paymentUrl, '_blank');
    }
      console.log("Payment initiated:", response.data);
      // If response has redirect URL or similar:
      // window.location.href = response.data.paymentUrl;
    } catch (error) {
      console.error("Payment error:", error);
    }
  };
console.log(user)
    const NewmemberType = (!user?.lifeTimeMember || user?.lifeTimeMember === ""|| user?.lifeTimeMember==="null") 
  ? "Non Member" 
  : "Life Member";

  const downloadIDCardHandler = () => {
    html2canvas(idCardRef.current, { useCORS: true }).then((canvas) => {
      const link = document.createElement("a");
      link.download = `${user.name}-id-card.png`;
      link.href = canvas.toDataURL("image/png");
      link.click();
    });
  };

    return(<div><DashBoardLeftProfileMenu/>
        <div className={'containerStyla ' + Style.Dashboardscreen}>
<Container>
     <DashboardTitle title="Membership" membertype="" />
        <Row>
            <Col>
            <div className={Style.Memberstatus}>
                    <h3>Current Status :</h3>
                    <Row>
                        <Col lg={6}>
                            <div className={Style.statusBox}>
                                {NewmemberType==="Non Member"?
                                    <h4><img src={require("../../assest/images/non-member-img.png")} alt=""/> {NewmemberType}</h4>
                                    :
                                    <h4><img src={require("../../assest/images/member-life.png")} alt=""/> {NewmemberType}</h4>
                                }
                            </div>
                            {NewmemberType==="Non Member"&&
                            <div className={Style.aboutMembership}>
                                <h3>Become A Member</h3>
                                <p>As a member you only help MAAD cover its expenses but also enjoy special discounts and offers for events organized by MAAD.</p>
                            </div>}
                        </Col>
                          {NewmemberType!=="Non Member"?
                        <Col lg={6}>
                            <div className={Style.lifeMember}>
                                <div className={Style.cardContainer}>
                                    {/* <button onClick={downloadIDCardHandler} className={Style.downloadCardBtn}><RiDownload2Fill /></button> */}
                                    <div ref={idCardRef} className={Style.lifeCard}>
                                        <div className={Style.cardHead}>
                                            <figure>
                                                <img src={constants.IMAGE_BASE_URL+'alumni/'+user.image}  alt=""/>
                                            </figure>
                                            <div className={Style.cardTitle}>
                                                <h4>Mayo Alumni Association Delhi</h4>
                                                <h5>Privilege / ID Card</h5>
                                                <h6>Life Member</h6>
                                            </div>
                                        </div>
                                        <div className={Style.cardInfo}>
                                            <ul>
                                                <li>Name : {user?.name}</li>
                                                <li>Batch : {user?.batch}</li>
                                                <li>School : {user?.school}</li>
                                                <li>ID Number : {user?.id_number}</li>
                                            </ul>
                                            <img src={require("../../assest/images/mayo-ajmer-logo.png")} className={Style.cardLogo} alt=""/>
                                        </div>
                                    </div>
                                </div>
                                <div className={Style.cardTerms}>
                                    <h6>Terms & Conditions</h6>
                                    <ul>
                                        <li>This card is not a credit/debit card.</li>
                                        <li>This card is not transferable.</li>
                                        <li>For information and offers kindly refer to : <Link to="www.mayoalumni.in">www.mayoalumni.in</Link>.</li>
                                        <li>Please present this card to avail benefits before you ask for the bill from the concerned establishment.</li>
                                        <li>Offers are subject to change without any prior notice.</li>
                                        <li>This card is for private circulation only & is the property of Mayo Alumni Association Delhi can be withdrawn at anytime & it has no legal binding.</li>
                                    </ul>
                                    <div className={Style.colouredBoxes}>
                                        <div className={Style.line + ' ' + Style.redColor}></div>
                                        <div className={Style.line + ' ' + Style.yelloecolor}></div>
                                        <div className={Style.line + ' ' + Style.bluecolor}></div>
                                        <div className={Style.line + ' ' + Style.whitecolor}></div>
                                        <div className={Style.line + ' ' + Style.greencolor}></div>
                                    </div>
                                </div>
                            </div>
                        </Col>:<Col lg={6}></Col>
                            }
                    </Row>
                </div>
            </Col>
        </Row>
        {NewmemberType==="Non Member"&&
        <Row>
            <Col lg={6}>
                <div className={Style.payOffer}>
                    <div className={Style.box}>
                        <div className={Style.lSide}>
                            <h2>Life Membership</h2>
                            <p>Rs. 7500 (One Time)</p>
                        </div>
                        <div className={Style.rSide}>

                                <button type="button" className={Style.greenBtn} onClick={handlePayment}>
                                    Pay Now
                                </button>
                        </div>
                    </div>
                </div>
            </Col>
            <Col lg={6}>
                <div className={Style.paymentOption}>
                    <h3>PAYMENT OPTIONS</h3>
                    <p>You will be given the option to select the payment option in the next screen</p>
                   <img className={Style.PaymentImg} src={require('../../assest/images/payment-img.png')} alt=""  />
                     <img src={require('../../assest/images/card-img.png')} alt=""/>
                </div>
            </Col>
       
        </Row>}
    </Container>
    </div>
    </div>
    )
}
export default DashBoardMembership;